import React from 'react'
import PropTypes from 'prop-types'

/**
 * Respaldo de `Suspense` mientras se descarga un trozo de la aplicación.
 *
 * ─── Por qué existe (H6, Fase 8) ────────────────────────────────────────────
 *
 * El respaldo del `Suspense` raíz era `<div />`: un hueco en blanco. Mientras
 * el trozo no llegaba, la pantalla se quedaba vacía **sin decir nada** — y ante
 * una pantalla en blanco lo que hace un operador es volver a pulsar, o pensar
 * que se ha roto.
 *
 * Dejó de ser un detalle en la Fase 8. Al pasar `MainContainer` a carga
 * diferida, este respaldo entró **en el camino crítico**: es lo que se ve
 * justo después de entrar, mientras baja el panel. Un hueco en blanco ahí es
 * exactamente el peor sitio.
 *
 * ─── Por qué no un esqueleto ────────────────────────────────────────────────
 *
 * Un esqueleto —cajas grises con la forma del contenido— funciona cuando se
 * sabe qué va a aparecer. Aquí no: el mismo respaldo cubre el panel entero, un
 * listado o un detalle. Dibujar la forma equivocada engaña más que un
 * indicador honesto.
 */
const PantallaCargando = ({ texto = 'Cargando…' }) => (
  <div
    role="status"
    aria-live="polite"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--urb-space-4)',
      minHeight: '60vh',
      color: 'var(--urb-text-muted)'
    }}
  >
    <i className="fa fa-spinner fa-spin fa-3x" aria-hidden="true" />
    <span>{texto}</span>
  </div>
)

PantallaCargando.propTypes = {
  /** Qué se está cargando, si se sabe. */
  texto: PropTypes.string
}

export default PantallaCargando
